import styled from "styled-components";

export const ModalPopupBG = styled.div`
    position:fixed;
    top:0px;
    left:0px;
    z-index: 30;
    display: ${({show}) => (show ? "block" : "none")};
    height: 100%;
    width:100vw;
    display:flex;
    backdrop-filter: invert(40%);
`;

export const ModalPopupHeader=styled.div`
  display:flex;
  padding:10px;

`;

export const ModalPopupBody=styled.div`
    display:flex;
    padding:10px;
    align-items:center;
`;

export const ModalPopupFooter=styled.div`
    display:flex;
    padding:10px;
    justify-content: center;
    flex-direction: column;
    align-items: center;
`;
export const ModalPopupWrapper = styled.div`
    z-index: ${({zindex}) => (zindex ? zindex : "31")};
    // display: ${({show}) => (show ? "block" : "none")};
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #FFFFFF;
    // display:flex;
    border-radius: 10px;
    overflowX: clip;
    padding:10px;
    min-width:500px;
    @media screen and (max-width: 600px){
        {
            max-height: 95% !important;
            height:auto !important;
            min-height: ${({select}) => (select ? "" : "max-content")}; !important;
            min-width: 90% !important;
            overflow: auto;
        }
    }
    
    @media screen and (min-width: 600px) and (max-width: 820px){
        {
            max-height: ${({maxheight}) => (maxheight ? maxheight : "55%")}; !important;
            height:auto !important;
            min-height: 30% !important;
            width: ${({width}) => (width ? width : "65%")}; !important;
        }
    }
    @media screen and (max-width: 375px){
        {
            width: 95% !important;
            overflow: auto;
            min-width:95%;
        }
    }
`;

export const ModalPopupTitle = styled.div`
    color: #000;
    font-family: Lato;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    overflow-y: clip;
    width: 95%;
    text-align: left;
    @media screen and (max-width: 600px){
        margin-top: 3.5%;
    }
`;

export const ModalPopupIcon = styled.div`
    width:15%;
    & img{
        width:70%;
    }
`;

export const ModalPopupText = styled.div`
    width: ${props=>props.policy?"60%":"85%"};
    height:auto;
    color: #111;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: 0.18px;
    overflow-x: clip;
    text-overflow: ellipsis;
    text-align: left;    
    ${props => props.homePolicy && `        
    & a {
        word-wrap: break-word;
    }

    @media screen and (max-width: 850px){
        word-wrap: break-word;
    }
 `
}
${props => props.policy && `
@media screen and (max-width: 375px){
    width: auto;
    top:  32%;
    left: 30%;
}
`
}

`;

export const YesButton = styled.button`
    display: flex;
    //width: 17vh;
    height: 6vh;
    padding: 13px 13px 13px 13px;
    justify-content: center;
    align-items: center;
    gap: 12px;
    // transform: translatex(-50%);
    flex-shrink: 0;
    border-radius: 8px;
    border: 1px solid #FF6B00;
    background: #F66700;
    box-shadow: rgb(199, 83, 0) 0px 3px 0px;
    & span{
        position:relative;
        color: #FFF;
        font-family: Lato;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
    }
    @media screen and (max-width: 850px){
        // top: 65%;
        
    }
    // @media screen and (max-width: 820px){
    //     top: 75%;
    // }
}`;

export const NoButton = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    // transform: translatex(-50%);
    background: #FFF;
    color: #C75300;
    cursor: pointer;
    margin-top: 15px;
    &: hover{
        color: #C75300;
    }
    @media screen and (max-width: 850px){
        top: 88%;
    }
    @media screen and (max-width: 600px){
        top: 85%;
    }
}`;

export const NotRightNow = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    color: #C75300;
 }
}`;

export const NoThanks = styled(NotRightNow)`
    color: #111111;
    bottom:16vh;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%;
`

export const OKReady = styled(NotRightNow)`
    font-size: 2.6vh;
    color: #000;
    bottom:4vh;
    cursor: pointer;
    &: hover{
        color: #C75300;
    }
}`;

export const ModalCloseButton = styled.a`{
    cursor: pointer;
    text-decoration:none;
    position:relative;
    width:5%;
    :after{
        position:absolute;
        content:"X";
        width:20px;
        height:10px;
        color:#999999;
        right:-10px;
        top:-10px;
    } 
}`;